import { Maybe, MfrmDeliveryService } from '~/gql/__generated__/types';

export const getDeliveryServiceWithSKU = (
  deliveryServices: MfrmDeliveryService,
): IDeliveryServiceFiltered[] => {
  const newDeliveryServiceArray: IDeliveryServiceFiltered[] = [];
  deliveryServices?.deliveryServices?.forEach((item) => {
    if (item) {
      const serviceItems = {
        serviceProductRecId: item.serviceProductRecId,
        serviceSku: item.serviceSku,
        addKeyInPrice: item.addKeyInPrice,
      };
      newDeliveryServiceArray.push(serviceItems);
      if (item?.childServices) {
        item.childServices.map((childItem) => {
          if (childItem) {
            const serviceItems = {
              serviceProductRecId: childItem.productRectId,
              serviceSku: childItem.serviceSku,
              addKeyInPrice: childItem.addKeyInPrice,
            };
            newDeliveryServiceArray.push(serviceItems);
          }
        });
      }
    }
  });

  return newDeliveryServiceArray;
};

interface IDeliveryServiceFiltered {
  serviceProductRecId: Maybe<number>;
  serviceSku: Maybe<string>;
  addKeyInPrice: boolean;
}
